import { Locale } from '../../../../types';
/**
 * Локализация JSON-данных.
 * @param data - Данные для локализации.
 * @param lang - Текущая локаль.
 * @param fallbackLang - Локаль по умолчанию.
 * @returns Локализованные данные.
 *
 * @example
 * const data = {
 * 	title: {
 * 		ru: 'Заголовок',
 * 		en: 'Title'
 * 	}
 * };
 *
 * const localizedData = localizeJson(data, Locale.English);
 *
 * console.log(localizedData); // { title: 'Title' }
 */
export const localizeJson = (data, lang, fallbackLang = Locale.Russian) => {
    if (Array.isArray(data)) {
        return data.map(item => localizeJson(item, lang, fallbackLang));
    }
    if (typeof data === 'object' && data !== null) {
        const obj = data;
        const keys = Object.keys(obj);
        if (keys.includes(lang) || keys.includes(fallbackLang)) {
            if (lang in obj) {
                return obj[lang];
            }
            if (fallbackLang in obj) {
                return obj[fallbackLang];
            }
            const firstKey = keys[0];
            return obj[firstKey];
        }
        const localizedObj = {};
        for (const key of keys) {
            localizedObj[key] = localizeJson(obj[key], lang, fallbackLang);
        }
        return localizedObj;
    }
    return data;
};
